var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.937 142.084C516.687 123.316 516.687 92.91 497.937 74.158L437.847 14.062C419.097 -4.688 388.662 -4.688 369.912 14.062L313.384 70.611L441.378 198.633L497.937 142.084ZM290.75 93.232L31.037 352.955C28.802 355.189 27.281 358.033 26.66 361.131L0.32 492.854C-1.92 504.049 7.951 513.92 19.144 511.68L150.855 485.334C153.953 484.715 156.796 483.193 159.031 480.961L418.75 221.258L290.75 93.232ZM552 464H248C234.746 464 224 474.744 224 488C224 501.254 234.746 512 248 512H552C565.253 512 576 501.254 576 488C576 474.744 565.253 464 552 464Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenLine);
export default __webpack_public_path__ + "static/media/pen-line.434ccf86d76497ed5e58f7d4128c1223.svg";
export { ForwardRef as ReactComponent };